<template>
  <div class="product" style="padding-top: 50px;">
    {{msg}}
    <xfck></xfck>
  </div>
</template>

<script>
  import xfck from './xfck.vue'
  export default {
    name: 'product',
    data() {
      return {
        msg: '产品服务'
      }
    },
     components:{
      xfck,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product.vue